import React from "react";
import { TableRow, TableCell, CellSeparator } from "../CustomTableStyles";

const TableRows = ({ columns, currentItems, font }) => {
  return (
    <>
      {currentItems.map((item, index) => (
        <TableRow key={index}>
          {columns.map((column, columnIndex) => (
            <React.Fragment key={`${column.key}-${index}`}>
              <TableCell
                key={column.key}
                font={font}
                hasEllipsis={column.ellipsis}
                columnWidth={column.width}
              >
                {column.render
                  ? column.render(item[column.dataIndex], item)
                  : item[column.dataIndex]}
              </TableCell>
              <CellSeparator width={"3px"} />
            </React.Fragment>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableRows;

